/* eslint-disable no-template-curly-in-string */
import R from 'ramda'
import { convertSendDarkTweetWidgetActionToFormAction } from '../widget-to-form/send-dark-tweet'

const SPEED_THREAD_START_WIDGET_TYPE = 'SPEED_THREAD_START'
const SPEED_THREAD_START_FORM_TYPE = 'Start Speed Thread'

const isSpeedThreadStartWidgetType = R.propEq(
  'type',
  SPEED_THREAD_START_WIDGET_TYPE
)

const convertSpeedThreadStartToForm = action => {
  // A saved start action with an empty success array has no start reply, so the
  // toggle opens off and we skip mapping reply fields. Otherwise restore the
  // reply and open the toggle on.
  const successReply = R.head(R.propOr([], 'success', action))
  const replyFields = successReply
    ? convertSendDarkTweetWidgetActionToFormAction(successReply)
    : {}
  const formAction = {
    ...replyFields,
    type: SPEED_THREAD_START_FORM_TYPE,
    sendStartReply: Boolean(successReply),
    speedThreadExpiration: R.pipe(
      R.prop('timeout'),
      R.defaultTo(0),
      R.divide(R.__, 1000)
    )(action),
    maxRetries: R.pipe(R.prop('maxRetries'), R.defaultTo(0))(action)
  }
  return formAction
}

export {
  isSpeedThreadStartWidgetType,
  convertSpeedThreadStartToForm,
  SPEED_THREAD_START_FORM_TYPE
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/start-speed-thread.js